const compareSettings = {
    categoryFamilies: [
        ['Conditions', 'Additional Conditions'],
        ['Exclusions', 'Property Not Covered'],
        [
            'Additional Coverages',
            'Coverage Extensions',
            'Covered Property',
            'Insuring Agreements',
            'Optional Coverages',
        ],
    ],
};
export default compareSettings;
